import { Icon, Text } from '@iziwork/design-system';
import Head from 'next/head';
import Link from 'next/link';
import React, { FC } from 'react';
import styled from 'styled-components';

import { Header } from '~/components';
import { useRouter, useTranslation } from '~/hooks';

const ErrorContainer = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
`;

const ErrorWrapper = styled.div`
  top: 50%;
  left: 50%;
  width: 100%;
  padding: 0 1rem;
  max-width: 1000px;
  position: absolute;
  text-align: center;
  box-sizing: border-box;
  transform: translate(-50%, -50%);
`;

const HomeLinkWrapper = styled.div`
  margin-top: 2rem;
`;

const HomeLink = styled(Text)`
  cursor: pointer;
  text-decoration: underline;
`;

const LinkIcon = styled(Icon)`
  margin-right: 1rem;
`;

interface ErrorTemplateProps extends React.PropsWithChildren {
  title: string;
}

export const ErrorTemplate: FC<ErrorTemplateProps> = ({ children, title }) => {
  const { t } = useTranslation();
  const { businessUnit, iframe } = useRouter();
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="robots" content="noindex" />
      </Head>
      <ErrorContainer>
        {!iframe && <Header />}
        <ErrorWrapper>
          {children}
          <HomeLinkWrapper>
            <Link href={`/${businessUnit.toLowerCase()}`} passHref>
              <HomeLink variant="body-lighter">
                <LinkIcon name="back-filled" />
                {t('error_pages.redirect_label')}
              </HomeLink>
            </Link>
          </HomeLinkWrapper>
        </ErrorWrapper>
      </ErrorContainer>
    </>
  );
};
